/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable react/jsx-indent */
/* eslint-disable react/jsx-curly-newline */

import { Button, Col, Drawer, Form, Input, Select, Switch } from 'antd';
import { useForm } from 'antd/lib/form/Form';
import React, { useCallback, useState } from 'react';

import IClientsList from '../../interfaces/clients';

interface IProps {
  showFilters: boolean;
  closeFilters: () => void;
  clients: IClientsList[];
  search(
    client_id: string,
    start_date: string,
    end_date: string,
  ): void;
}

const { Option } = Select;

const ClientsConsumptionReportFilters: React.FC<IProps> = props => {
  const { showFilters, closeFilters, search, clients } =
    props;
  const [filters, setFilters] = useState({
    client_id: '',
    start_date: '',
    end_date: '',
  });

  const [form] = useForm();

  const onSearch = useCallback(() => {
    const { client_id, start_date, end_date } = form.getFieldsValue();

    search(
      client_id === undefined ? '' : client_id,
      start_date === undefined ? '' : start_date,
      end_date === undefined ? '' : end_date,
    );
  }, [form, search]);


  return (
    <Drawer
      title="Filtros de pesquisa"
      placement="right"
      closable={false}
      onClose={closeFilters}
      visible={showFilters}
    >
      <Form layout="vertical" onFinish={onSearch} form={form}>
        <Col span={24}>
          <Form.Item label="Cliente" name="client_id"  rules={[
            {
              required: true,
              message: 'Por favor, selecione um cliente!',
            },
          ]}>
            <Select
              allowClear
              placeholder="Todos"
              filterOption
              showSearch
              optionFilterProp="children"
              className="dcs-select"
              onChange={e => setFilters({ ...filters, client_id: String(e) })}
            >
              {clients.map(client => (
                <Option key={client.id} value={client.id}>
                  {client.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Data início" name="start_date"  rules={[
            {
              required: true,
              message: 'Por favor, selecione uma data inicial!',
            },
          ]}>
            <Input
              className="dcs-input"
              allowClear
              type="date"
              onChange={e =>
                setFilters({ ...filters, start_date: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Col span={24}>
          <Form.Item label="Data fim" name="end_date"  rules={[
            {
              required: true,
              message: 'Por favor, selecione uma data final!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const startDate = getFieldValue('start_date');
                if (!value || !startDate || new Date(value) >= new Date(startDate)) {
                  return Promise.resolve();
                }
                return Promise.reject(
                  new Error('A data final não pode ser anterior à data inicial!')
                );
              },
            }),
          ]}>
            <Input
              className="dcs-input"
              allowClear
              type="date"
              onChange={e =>
                setFilters({ ...filters, end_date: e.target.value })
              }
            />
          </Form.Item>
        </Col>
        <Form.Item>
          <Button type="primary" shape="round" htmlType="submit">
            Buscar
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default ClientsConsumptionReportFilters;
